module.exports = require("./nmg");